
import AnimationOverlay from '~/components/core/AnimationOverlay';
export default {
  components: { AnimationOverlay },
  props: {
    title: {
      type: String,
      default: ""
    },
    ratings: {
      type: Number,
      default: 0
    },
    tourType: {
      type: String,
    },
    city: {
      type: String,
    },
    area: {
      type: String,
    },
    noOfReviews: {
      type: Number,
      default: 0
    },
    shortDesc: {
      type: String
    }
  }
}

